import React, { FC, useState, memo } from "../../../lib/teact/teact";
import DropdownMenu from "../../ui/DropdownMenu";
import InputText from "../../ui/InputText";
import MenuItem from "../../ui/MenuItem";
import SearchInput from "../../ui/SearchInput";
import { LotScreenSettings } from "../config/uiconfig";
import SystemMessageDialog from "../systemmessages/systemMessageDialog";
import SystemMessagesScreen from "../systemmessages/systemMessagesScreen";
import '../ui/formCommon.scss'
import AgentList from "./AgentList";
import AgentListEx from "./AgentListEx";
import ApiCall from "./ApiCall";
import CreateAgent from "./CreateAgent";
type OwnProps = {
    backToScreen: LotScreenSettings;
    onChangeScreen: (screen: LotScreenSettings) => void;
}
//
export enum AdminScreens {
    AgentList,
    AgentListEx,
    CreateAgent,
    EditAgent,
    ApiCall,
    MessageToCustomer,
}
const AdminScreen: FC<OwnProps> = ({
    onChangeScreen,
    backToScreen
}) => {
    const [state, setState] = useState({
        curScreen: AdminScreens.AgentList,
        dataFilter: "",

        data: {}
    })
    function handleMenuClick(screen: AdminScreens) {
        setState(prev => ({ ...prev, curScreen: screen }))
    }
    function handleChangeScreen(data: any) {
        setState(prev => ({
            ...prev, curScreen: AdminScreens.EditAgent,
            data: data
        }))
    }
    const role = localStorage["userGroupRole"]
    return (
        <div className=" form-main">

            <div className=" form-header">

                <div className="form-header left-panel">
                    <DropdownMenu>
                        <MenuItem onClick={() => { handleMenuClick(AdminScreens.CreateAgent) }}>
                            Tạo tài khoản
                        </MenuItem>
                        <MenuItem onClick={() => { handleMenuClick(AdminScreens.AgentList) }}>
                            Danh sách tài khoản cấp dưới
                        </MenuItem>
                        <MenuItem onClick={() => onChangeScreen(backToScreen)}>
                            Thoát
                        </MenuItem>
                        {
                            (role == "admin_lv0" || role == "admin_lv1" || role == "admin_lv2") &&
                            <>
                                <MenuItem onClick={() => handleMenuClick(AdminScreens.ApiCall)}>
                                    Quản trị hệ thống
                                </MenuItem>
                                <MenuItem onClick={() => handleMenuClick(AdminScreens.AgentListEx)}>
                                    Thống kê khách hàng
                                </MenuItem>
                                <MenuItem onClick={() => handleMenuClick(AdminScreens.MessageToCustomer)}>
                                    Thông báo khách hàng
                                </MenuItem>
                            </>
                        }

                    </DropdownMenu>


                    <SearchInput
                        inputId="user-search-input"
                        parentContainerClassName="LeftSearch"
                        onChange={(e) => { setState(prev => ({ ...prev, dataFilter: e })) }}
                    >
                    </SearchInput>
                </div>

            </div>
            {/* Danh sách tài khoản  */}
            {
                state.curScreen == AdminScreens.AgentList &&
                <AgentList dataFilter={state.dataFilter} onChangeScreen={handleChangeScreen} />
            }
            {/* Tạo tài khoản mới */}
            {
                state.curScreen == AdminScreens.CreateAgent &&
                <CreateAgent editType="add" />
            }
            {/* Sủa đổi thông tin, cấp quyền */}
            {
                state.curScreen == AdminScreens.EditAgent &&
                <CreateAgent editType="edit" curUser={state.data} />
            }
            {/* API call */}
            {
                state.curScreen == AdminScreens.ApiCall &&
                <ApiCall />
            }
            {
                state.curScreen == AdminScreens.MessageToCustomer &&
                <SystemMessagesScreen />
            }
            {
                state.curScreen == AdminScreens.AgentListEx &&
                <AgentListEx dataFilter={state.dataFilter} onChangeScreen={handleChangeScreen} />
            }
        </div >
    )
}

export default memo(AdminScreen);